/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import { useNavigate, useParams } from 'react-router-dom'

export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [category, setCategory] = useState([])
  const { page_id } = useParams()
  const getCategories = async () => {
    console.log("getCategories", page_id)
    const { response } = await AppService.onboardlistcategory.get({
      // query: `category_id=${page_id}`,
        query: `category_id=${page_id}&type=superadmin`,
      toaster: false,
    })
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
  }

  useEffect(() => {
    getCategories()
  }, [])
  const navigate = useNavigate()

  const getAppTypes = async () => {
    const { response } = await AppService.onboarding_list.filter({
      query: `category_id=${page_id}&type=superadmin`,
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }

  const onLoad = () => {
    getAppTypes()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.onboarding_list.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])
  const truncateText = (text, wordLimit = 8) => {
    if (!text) return "";
    const words = text.split(" ");
    return words.length > wordLimit ? words.slice(0, wordLimit).join(" ") + "..." : text;
  };

  return {
    loader: loader,
    category: category,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'Description', accessor: 'description' },
        { Header: 'image', accessor: 'image' },
        { Header: 'Video Path', accessor: 'video_path' },
        { Header: 'Page Path', accessor: 'page_path' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'status', accessor: 'status' },
        { Header: 'points', accessor: 'points' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: list.map((data) => ({
        name: data.name ? `${data.name.substring(0, 20)}...` : "",
        description: data.description
          ? `${data.description.replace(/<[^>]+>/g, "").substring(0, 30)}...`
          : "",
        video_path: data.video_path ? `${data.video_path.substring(0, 20)}...` : "",
        image: data.image,
        page_path: data.page_path ? `${data.page_path.substring(0, 20)}...` : "",
        type: data.type,
        status: data.status,
        points: data.points,


        action: (
          <MDBox>
            <div style={{ display: "flex", gap: "1rem" }}>

              <EditModal data={data} handleRefresh={onLoad} category={category} />

              {/* <ViewModal data={data} handleRefresh={onLoad} /> */}
              {
                data.custom_buttons && (
                  <MDButton
                    variant="contained"
                    color="warning"
                    size="small"
                    sx={{ marginLeft: 2 }}
                    onClick={() => navigate(`./${data._id}`)}
                  >
                    Custom Buttons
                  </MDButton>
                )
              }
              <MDButton
                variant="contained"
                color="error"
                size="small"
                sx={{ marginLeft: 2 }}
                onClick={() => handleDelete(data._id)}
              >
                Delete
              </MDButton>
            </div>
          </MDBox>
        ),
      })),
    },
  }
}
